import Head from '@/src/assets/png/flightHead.png'
import Tail from '@/src/assets/png/flightTail.png'
import { Row, SeatDetail } from '@/src/types/itinerary'
import { Box, Typography } from '@mui/material'
import Image from 'next/image'
import SeatRowWrapper from '../seatRow'

const Aircraft = ({
    columnHeadersRef,
    scrollContainerRef,
    craftWidth,
    seatColumns,
    rows,
    totalColumns,
    selectedSeatOptions,
    headAndTailHeight,
    handleAddSeat,
    handleRemoveSeat,
    getSeatColor,
    formatCurrency
}: {
    columnHeadersRef: React.RefObject<HTMLDivElement>
    scrollContainerRef: React.RefObject<HTMLDivElement>
    craftWidth: number
    seatColumns: string[]
    rows: Row[]
    totalColumns: number
    selectedSeatOptions: Partial<SeatDetail>[]
    headAndTailHeight: number
    handleAddSeat: (seat: SeatDetail) => void
    handleRemoveSeat: (seat: SeatDetail) => void
    getSeatColor: (price: number) => string
    formatCurrency: (price: number) => string
}) => {
    return (
        <Box
            sx={{
                flex: 1,
                overflowY: 'auto',
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': {
                    display: 'none'
                }
            }}
            ref={scrollContainerRef}
        >
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    minWidth: craftWidth,
                    alignItems: 'center'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: -2
                    }}
                >
                    <Image src={Head.src} width={craftWidth} height={headAndTailHeight} alt="Flight Tail" />
                </Box>

                <Box
                    sx={{
                        position: 'relative',
                        background: 'white',
                        pb: 2,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {/* Column Headers */}
                    <Box
                        sx={{
                            display: 'flex',
                            position: 'sticky',
                            top: 0,
                            pt: 1,
                            zIndex: 10,
                            backgroundColor: 'neutral.white'
                        }}
                        ref={columnHeadersRef}
                    >
                        <Box
                            sx={{
                                width: 36,
                                height: 32
                            }}
                        ></Box>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 1,
                                '&:dir(rtl)': {
                                    flexDirection: 'row-reverse'
                                }
                            }}
                        >
                            {seatColumns.map((col, index) => (
                                <Typography
                                    key={index}
                                    variant="body1"
                                    sx={{
                                        width: 30,
                                        textAlign: 'center',
                                        fontWeight: 700,
                                        color: col ? 'primary.main' : 'transparent',
                                        fontSize: 14
                                    }}
                                >
                                    {col}
                                </Typography>
                            ))}
                        </Box>
                        <Box
                            sx={{
                                width: 36,
                                height: 32
                            }}
                        ></Box>
                    </Box>

                    {/* Grid Container */}
                    <Box>
                        {rows.map((row, rowIndex) => {
                            const { rowCharacteristics, rowId, seatDetails } = row
                            return (
                                <SeatRowWrapper
                                    key={rowCharacteristics + rowIndex}
                                    rowIndex={rowIndex}
                                    rowId={rowId}
                                    rowCharacteristics={rowCharacteristics}
                                    seatDetails={seatDetails}
                                    totalColumns={totalColumns}
                                    selectedSeatOptions={selectedSeatOptions}
                                    handleAddSeat={handleAddSeat}
                                    handleRemoveSeat={handleRemoveSeat}
                                    getSeatColor={getSeatColor}
                                    formatCurrency={formatCurrency}
                                />
                            )
                        })}
                    </Box>
                </Box>

                <Box
                    sx={{
                        borderRadius: '0 0 20px 20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: -2
                    }}
                >
                    <Image src={Tail.src} width={craftWidth} height={headAndTailHeight} alt="Flight Tail" />
                </Box>
            </Box>
        </Box>
    )
}

export default Aircraft
